import { Location } from '@angular/common';
import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from 'components/base/base.component';
import { CardArquivoAnexadoComponent } from 'components/card-arquivo-anexado/card-arquivo-anexado.component';
import { VisualizarArquivoComponent } from 'components/visualizar-arquivo/visualizar-arquivo.component';
import { FiltroPadraoComponent } from 'components/filtro-padrao/filtro-padrao.component';
import { lastValueFrom } from 'rxjs';
import { Perfil } from 'src/app/shared/enums/Perfis/Perfis';
import { ArquivoAzure } from 'src/app/shared/models/arquivo/ArquivoAzure';
import { Envolvido } from 'src/app/shared/models/chamados/envolvido';
import { ListarChamados } from 'src/app/shared/models/chamados/listar-chamados';
import { DefaultResponse } from 'src/app/shared/models/DefaultResponse';
import { Diretoria } from 'src/app/shared/models/diretoria/Diretoria';
import { Aluno } from 'src/app/shared/models/envolvidos/aluno';
import { Funcionario } from 'src/app/shared/models/envolvidos/funcionario';
import { FiltroPadrao } from 'src/app/shared/models/filtro-padrao/filtroPadrao';
import { AgendamentoPrevencaoDto } from 'src/app/shared/models/psicologo/AgendamentoPrevencaoDto';
import { EditarJornadaAtividade } from 'src/app/shared/models/psicologo/EditarJornadaAtividade';
import { JornadaPsicologo, JornadaPsicologoAtividade, JornadaPsicologoAtividadeEnvolvido } from 'src/app/shared/models/psicologo/JornadaPsicologo';
import { AtribuicaoLoginSed } from 'src/app/shared/models/sed/UserLogin';
import { Turma } from 'src/app/shared/models/turma/Turma';
import { AlunoService } from 'src/app/shared/services/alunos.service';
import { ArquivoService } from 'src/app/shared/services/arquivo.service';
import { ChamadoService } from 'src/app/shared/services/chamado.service';
import { ConvivaErrorHandlingService } from 'src/app/shared/services/convivaErrorHandlingService';
import { EnvolvidoService } from 'src/app/shared/services/envolvido.service';
import { FiltroService } from 'src/app/shared/services/filtro.service';
import { FuncionarioService } from 'src/app/shared/services/funcionarios.service';
import { angularCommonImports } from 'src/app/shared/ui/angular-common';
import { convivaCommonImports } from 'src/app/shared/ui/conviva-common';
import { libsCommonImports } from 'src/app/shared/ui/libs-common';
import { GenericValidator } from 'src/app/shared/validations/genericValidators';
import { SpeechRecognitionService } from 'src/app/speech-recognition.service';
import { CellComponent } from 'tabulator-tables';
import { Escola } from './../../../../shared/models/escola/Escola';


@Component({
    templateUrl: './editar-jornada-atividade.component.html',
    styleUrls: ['./editar-jornada-atividade.component.scss'],
    standalone: true,
    imports:[angularCommonImports,convivaCommonImports,libsCommonImports,CardArquivoAnexadoComponent,VisualizarArquivoComponent]
})

export class PageEditarAtividadeComponent extends BaseComponent implements OnInit {

  @ViewChild(FiltroPadraoComponent) filtroPadrao: FiltroPadraoComponent;

  public atividadeId: number;
  public jornadaId: number;
  public atividade: JornadaPsicologoAtividade;
  public jornada: JornadaPsicologo;
  //public duracaoVisita = 15;
  public submitted: boolean = false;

  formEditar!: FormGroup;
  formModalAluno!: FormGroup;
  formModalOutros!: FormGroup;
  formModalEquipeEscolar!: FormGroup;
  isListening = false;
  descricaoProximosPassos = '';
  descricaoAcaoRealizada = '';
  codigoAgendamento?: number;
  codigoNovoChamado?: number;
  showModalDeletarArquivo = false;
  codigoArquivoRemover?: number;
  showModalVisualizarArquivo = false;
  arquivoVisualizando?: ArquivoAzure;
  arquivoRemover?: ArquivoAzure;
  // codigoEscola?: number;
  public files: ArquivoAzure[] = [];
  get formControls() { return this.formEditar.controls; }


  async ngOnInit() {
    this.spinnerService.show();

    this.formEditar = new FormGroup({
      nomePsicologo: new FormControl({ value: this.userLogado?.nome, disabled: false }),
      dataAtividade: new FormControl(null),
      dataOperacao: new FormControl(null),
      tituloAcao: new FormControl(null, [Validators.required]),
      duracaoAcao: new FormControl(15),
      tipoAtividade: new FormControl(null, Validators.required),
      atividadeRealizada: new FormControl(null),
      tipoGrupo: new FormControl(null),
      acaoRealizada: new FormControl(null, [Validators.required, Validators.minLength(50), Validators.maxLength(500)]),
      proximosPassos: new FormControl(null, [Validators.required, Validators.minLength(50), Validators.maxLength(500)]),
      arquivos: new FormControl(null),
      codigoEscolaApenasDiretoria: new FormControl(null),
    });

    this.setQueryParams();
    await this.getJornadaPorId();
    await this.getAtividadePorId();
    await this.setDadosForm();

    // Set the escola filter AFTER all data is loaded
    await this.setEscolaInFiltroAfterDataLoaded();

    this.spinnerService.hide();
    if(!this.filtros?.codigoEscola && !this.userLogado?.codigoEscola){
      await this.getEscolasApenasDiretoria();
    }
    // this.getPsicologoPorCPF();

  }

  private async setEscolaInFiltroAfterDataLoaded() {
    // Wait for filtro-padrao component to be initialized
    let attempts = 0;
    while (!this.filtroPadrao && attempts < 20) {
      await new Promise(resolve => setTimeout(resolve, 100));
      attempts++;
    }

    const codigoEscola = this.atividade?.codigoEscola || this.jornada?.codigoEscola;

    if (codigoEscola && this.filtroPadrao) {
      await this.setEscolaInFiltro(codigoEscola);
    }
  }

  private async setEscolaInFiltro(codigoEscola: number) {
    // Wait for filtro-padrao to fully initialize and load escolas
    await new Promise(resolve => setTimeout(resolve, 1500));

    const formFilter = this.filtroPadrao?.formFilter;
    if (formFilter) {
      const codigoEscolaControl = formFilter.get('codigoEscola');
      if (codigoEscolaControl) {
        codigoEscolaControl.setValue(codigoEscola);
        // Call activeEscola to load turnos if needed
        if (this.filtroPadrao.activeEscola) {
          await this.filtroPadrao.activeEscola();
        }
      }
    }
  }

  setQueryParams() {
    this.activatedRoute
      .queryParams
      .subscribe(params => {
        this.atividadeId = params.atividadeId;
        this.jornadaId = params.jornadaId;
      });
  }

  async getAtividadePorId() {
    this.spinnerService.show();
    const response = await lastValueFrom(this.psicologoService.getAtividadePorId(this.atividadeId));
    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }
    this.atividade = response.data;
    this.toastr.success('Atividade encontrada com sucesso!');
    this.spinnerService.hide();
  }

  async getJornadaPorId() {
    this.spinnerService.show();
    const response = await lastValueFrom(this.psicologoService.getJornadaPorId(this.jornadaId));
    if (!response.isSucess) {
      this.toastr.error(response.message, response.title);
      this.spinnerService.hide();
      return;
    }

    this.jornada = response.data;
    this.toastr.success("Jornada encontrada com sucesso!");
    this.spinnerService.hide();

  }

  async setDadosForm() {
    this.codigoNovoChamado = this.atividade.codigoChamado;

    if (this.atividade.dataAtividade) {
      const date = new Date(this.atividade.dataAtividade);

      if (!isNaN(date.getTime())) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const datetimeLocalFormat = `${year}-${month}-${day}T${hours}:${minutes}`;
        this.formControls.dataAtividade.setValue(datetimeLocalFormat);
      } 
    } 

    if (this.atividade.dataOperacao) {
      const date = new Date(this.atividade.dataOperacao);

      if (!isNaN(date.getTime())) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const datetimeLocalFormat = `${year}-${month}-${day}T${hours}:${minutes}`;
        this.formControls.dataOperacao.setValue(datetimeLocalFormat);
      } 
    } 

    this.formControls.tituloAcao.setValue(this.atividade.titulo);
    this.formControls.tipoAtividade.setValue(this.atividade.tipoAtividade);
    await this.onTipoAtividadeChange(this.atividade.tipoAtividade);
    this.formControls.atividadeRealizada.setValue(this.atividade.tipoAtividadeRealizada);
    this.opcoesPrevencao();
    this.formControls.tipoGrupo.setValue(this.atividade.tipoAtividadeGrupo);
    if (this.atividade.tipoAtividadeRealizada == 2)
      await this.mostrarTipoGrupo();
    if (this.atividade.tipoAtividadeRealizada == 1)
      this.popularAluno();

    // else
    // this.mostrarAlunos
    this.descricaoAcaoRealizada = this.atividade.descricaoAcaoRealizada;
    this.formControls.acaoRealizada.setValue(this.atividade.descricaoAcaoRealizada);
    this.qtdeCaracteresAcao = this.atividade.descricaoAcaoRealizada.length;
    this.descricaoProximosPassos = this.atividade.descricaoProximosPassos;
    this.formControls.proximosPassos.setValue(this.atividade.descricaoProximosPassos);
    this.qtdeCaracteresPassos = this.atividade.descricaoProximosPassos.length;
    this.formControls.duracaoAcao.setValue(Number(this.atividade.tempoAtividade));



    this.setFilesAtividade();
    this.disabilitaCamposNaoEditaveis()
  }
  popularAluno() {
    this.alunosSelecionados = this.atividade.envolvidos;

  }

  setFilesAtividade() {
    this.files = this.atividade.arquivos.map(arq => {
      const item: ArquivoAzure = {
        nome: arq.nomeArquivo,
        caminhoAzure: arq.caminhoArquivo,
        conteudo: '',
        ehBase64: false,
        dataOperacao: arq.dataOperacao,
        nomeOriginal: arq.nomeArquivoOriginal
      }
      return item;
    })
  }

  setOcorrenciaAtendida() {

  }

  toggleListeningAcaoRealizada() {
    if (this.isListening) {
      this.speechRecognitionService.stopListening();
      this.isListening = false;
    } else {
      this.isListening = true;
      this.speechRecognitionService.startListening()
        .then(transcript => {
          this.descricaoAcaoRealizada += transcript;
          this.isListening = false;
        })
        .catch(error => {
          console.error('Erro no reconhecimento de voz:', error);
          this.isListening = false;
        });
    }
  }

  toggleListeningProximosPassos() {
    if (this.isListening) {
      this.speechRecognitionService.stopListening();
      this.isListening = false;
    } else {
      this.isListening = true;
      this.speechRecognitionService.startListening()
        .then(transcript => {
          this.descricaoProximosPassos += transcript;
          this.isListening = false;
        })
        .catch(error => {
          console.error('Erro no reconhecimento de voz:', error);
          this.isListening = false;
        });
    }
  }



  //Objetos e filtros
  // public psicologo: Psicologo;
  public lstOcorrenciasAgendadas: ListarChamados[] = [];
  public lstAgendamentoPrevencao: AgendamentoPrevencaoDto[] = [];
  public lstEnvolvidos: Envolvido[] = [];
  public lstEnvolvidosSelecionados: Envolvido[] = [];
  public alunosSelecionados: JornadaPsicologoAtividadeEnvolvido[] = [];
  public alunos: Aluno[] = [];
  public escolasModalAlunos: Escola[] = [];
  public aluno: Aluno = <Aluno>{};
  public lstTurmas: Turma[] = [];
  escolasDiretor: Escola[] = this.escolas;
  // public lstTurmasAtivas: number[] = [];
  public lstTurmasSelecionadas: JornadaPsicologoAtividadeEnvolvido[] = [];
  public envolvidos: Envolvido[] = [];
  public qtdeCaracteresAcao: number = 0;
  public qtdeCaracteresPassos: number = 0;
  lstFuncionariosSelecionados: Funcionario[] = [];
  public lstFuncionarios: Funcionario[] = [];
  lstOutros: string[] = [];

  //Injections
  errorHandler = inject(ConvivaErrorHandlingService);
  filtroService = inject(FiltroService);
  chamadoService = inject(ChamadoService);
  envolvidoService = inject(EnvolvidoService);
  alunoService = inject(AlunoService);
  speechRecognitionService = inject(SpeechRecognitionService);
  genericValidate = inject(GenericValidator);
  funcionarioService = inject(FuncionarioService);
  activatedRoute = inject(ActivatedRoute);
  arquivoService = inject(ArquivoService);
  location = inject(Location);
  mostrarAgendados = false;
  mostrarNaoAgendados = false;

  mostrarGridAcolhimento = false;
  mostrarGridPrevencao = false;
  mostrarAlunos = false;
  mostrarAlunosPrevencao = false;
  showOpcoesPrevencao = false;
  showModalAluno = false;
  showDropAuxiliar = false;
  validaBuscaRA = false;
  mostrarGrupos = false;
  mostrarDivTurmas = false;
  mostrarDivEquipeEscolar = false;
  mostrarDivOutros = false;
  showModalOutros = false;
  submittedModal = false;
  showModalEquipeEscolar = false;
  showDropFuncionarios = false;
  



  setUserLogado() {
    const user = this.authService.getUser();
    if (!user)
      this.router.navigate(['/logout']);

    return user;
  }

  public gridAcolhimentoAgendado = [
    { title: 'DE', field: 'nomeDiretoria', width: 150, hozAlign: "center", headerHozAlign: "center" },
    { title: 'Escola', field: 'nomeEscola', width: 200, hozAlign: "center", headerHozAlign: "center", formatter: "textarea" },
    { title: 'Código Chamado', field: 'codigoChamado', width: 150, hozAlign: "center", headerHozAlign: "center", formatter: "textarea" },
    { title: 'Envolvido', field: 'nomeEnvolvido', width: 200, hozAlign: "center", headerHozAlign: "center", formatter: "textarea" },
    { title: 'Psicólogo', field: 'nomePsicologo', width: 200, hozAlign: "center", headerHozAlign: "center" },
    {
      title: 'Data agendamento', field: 'dataAgendamento', width: 150, hozAlign: "center", headerHozAlign: "center", formatter: function (cell: any) {
        const value = cell.getValue();
        if (!value) return '';

        const date = new Date(value);
        if (isNaN(date.getTime())) return value;

        const dia = String(date.getDate()).padStart(2, '0');
        const mes = String(date.getMonth() + 1).padStart(2, '0');
        const ano = date.getFullYear();

        return `${dia}/${mes}/${ano}`;
      }
    },
    {
      title: 'Ações',
      field: 'acoes',
      hozAlign: "center",
      headerHozAlign: "center",
      width: 100,
      formatter: "toggle",
      formatterParams: {
        size: 20,
        onValue: true,
        offValue: false,
        onColor: "green",
        offColor: "grey",
        clickable: false
      },
      // cellMouseDown: (e: MouseEvent, cell: CellComponent) => {
      //   const table = cell.getTable();
      //   const currentValue = cell.getValue();
      //   const rowData = cell.getRow().getData();
      //   if (!currentValue) {
      //     // Desmarca todos os outros toggles
      //     table.getRows().forEach((row) => {
      //       if (row !== cell.getRow()) {
      //         row.update({ acoes: false });
      //         this.lstEnvolvidosSelecionados = [];
      //       }
      //     });
      //     // Marca o toggle atual
      //     cell.setValue(true);
      //     this.setChamadoAgendamento(rowData);
      //     this.getEnvolvidosPorChamado();
      //   } else {
      //     // Desmarca o toggle atual
      //     cell.setValue(false);
      //     this.mostrarAlunos = false;
      //     this.codigoNovoChamado = undefined;
      //     this.codigoAgendamento = undefined;
      //   }
      // }
    }
  ];

  public gridPrevencaoAgendado = [
    { title: 'DE', field: 'nomeDiretoria', width: 150, hozAlign: "center", headerHozAlign: "center" },
    { title: 'Escola', field: 'nomeEscola', width: 200, hozAlign: "center", headerHozAlign: "center", formatter: "textarea" },
    { title: 'Código Prevenção', field: 'codigoAgendamento', width: 150, hozAlign: "center", headerHozAlign: "center", formatter: "textarea" },
    { title: 'Psicólogo', field: 'nomePsicologo', width: 200, hozAlign: "center", headerHozAlign: "center" },
    {
      title: 'Data agendamento', field: 'dataAgendamento', width: 150, hozAlign: "center", headerHozAlign: "center", formatter: function (cell: any) {
        const value = cell.getValue();
        if (!value) return '';

        const date = new Date(value);
        if (isNaN(date.getTime())) return value;

        const dia = String(date.getDate()).padStart(2, '0');
        const mes = String(date.getMonth() + 1).padStart(2, '0');
        const ano = date.getFullYear();

        return `${dia}/${mes}/${ano}`;
      }
    },
    {
      title: 'Ações',
      field: 'acoes',
      hozAlign: "center",
      headerHozAlign: "center",
      width: 100,
      formatter: "toggle",
      formatterParams: {
        size: 20,
        onValue: true,
        offValue: false,
        onColor: "green",
        offColor: "grey",
        clickable: false
      },
      // cellMouseDown: (e: MouseEvent, cell: CellComponent) => {
      //   const table = cell.getTable();
      //   const currentValue = cell.getValue();

      //   if (!currentValue) {
      //     // Desmarca todos os outros toggles
      //     table.getRows().forEach((row) => {
      //       if (row !== cell.getRow()) {
      //         row.update({ acoes: false });
      //       }
      //     });

      //     // Marca o toggle atual
      //     cell.setValue(true);

      //     // Chama a função desejada com os dados da linha
      //     const rowData = cell.getData();
      //     this.getEnvolvidosPorChamado();
      //   } else {
      //     // Desmarca o toggle atual
      //     cell.setValue(false);
      //   }
      // }
    }
  ];

  public gridTurmasPrevencao = [
    { title: 'Código da Turma', field: 'codigoTurma', width: 150, hozAlign: "center", headerHozAlign: "center" },
    { title: 'Número Classe', field: 'numeroClasse', width: 200, hozAlign: "center", headerHozAlign: "center", formatter: "textarea" },
    { title: 'Tipo de Ensino', field: 'nomeTipoEnsino', width: 150, hozAlign: "center", headerHozAlign: "center", formatter: "textarea" },
    { title: 'Número de Série', field: 'numeroSerie', width: 200, hozAlign: "center", headerHozAlign: "center", formatter: "textarea" },
    { title: 'Descrição Turma', field: 'descricaoTurma', width: 200, hozAlign: "center", headerHozAlign: "center" },
    {
      title: 'Ações',
      field: 'acoes',
      hozAlign: "center",
      headerHozAlign: "center",
      width: 100,
      formatter: "toggle",
      formatterParams: {
        size: 20,
        onValue: true,
        offValue: false,
        onColor: "green",
        offColor: "grey",
        clickable: true
      },
      cellMouseDown: (e: MouseEvent, cell: CellComponent) => {
        const rowData = cell.getData();
        const codigoTurma = rowData.codigoTurma;
        const descricaoTurma = rowData.descricaoTurma;

        // Chama a função onCheckTurma com os dados da linha
        this.onCheckTurma(codigoTurma, descricaoTurma);

        // Alterna o valor do toggle
        const currentValue = cell.getValue();
        cell.setValue(!currentValue);
      }
    }
  ];

  // public async exibirEnvolvidosAcolhimentoAgendado(e: any, cell: any, toggleValue: boolean) {
  //   const rowData = cell.getData();
  //   const codigoChamado = rowData.codigoChamado;
  //   await this.getEnvolvidosPorChamado(codigoChamado);
  //   this.mostrarAlunos = true;
  // }
  // public async exibirEnvolvidosAcolhimentoAgendadoSemToggle(codigoChamado:number) {

  //   await this.getEnvolvidosPorChamado(codigoChamado);
  //   this.mostrarAlunos = true;
  // }


  public async getEnvolvidosPorChamado() {
    this.spinnerService.show();

    const response = await lastValueFrom(
      this.envolvidoService.GetEnvolvidosPorChamado(this.codigoNovoChamado!));

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }


    this.lstEnvolvidos = response.data;
    this.lstEnvolvidosSelecionados = this.lstEnvolvidos
      .filter(x => this.atividade.envolvidos?.some(s => +s.codigoEnvolvido! == +x.codigoEnvolvido!) && x.codigoChamado == this.codigoNovoChamado);


    this.mostrarAlunos = true;
    this.spinnerService.hide();

  }

  public addEnvolvidoOnLstEnvolvidoSelecionado(codigoEnvolvido: number, target: EventTarget) {
    const checkbox = target as HTMLInputElement;
    if (checkbox.checked)
      this.lstEnvolvidosSelecionados.push(this.lstEnvolvidos.find(x => x.codigoEnvolvido == codigoEnvolvido)!);
    else
      this.lstEnvolvidosSelecionados = this.lstEnvolvidosSelecionados.filter(x => x.codigoEnvolvido != codigoEnvolvido);
  }

  public async carregarTurmas() {
    this.submitted = true;

    let codigoEscola = this.jornada.codigoEscola ;
    if (!codigoEscola || codigoEscola == 0) {
     codigoEscola = this.formControls.codigoEscolaApenasDiretoria.value
    }

    this.spinnerService.show();
    const result = await lastValueFrom(this.escolaService.getTurmasPorCodigoCie(codigoEscola, 0))
      .catch((err) => {
        return this.errorHandler.handleResultError(err);
      });
    if (!result.isSucess) {
      this.toastr.error(result.message, result.title);
      this.spinnerService.hide();
      return;
    }
    this.lstTurmas = result.data.map((t: any) => ({
      ...t,
      // marca 'true' sempre que essa turma já estiver na lista de envolvidos da atividade
      acoes: this.atividade.envolvidos.some(e => Number(e.codigoTurma) === t.codigoTurma),
    }));


    this.spinnerService.hide();
    this.mostrarDivTurmas = true;

  }

  async getTurmaPorId(){
    const response = await lastValueFrom(this.alunoService.getTurmaPorId(this.atividade.envolvidos[0].codigoTurma!));
    if(!response.isSucess){
      this.toastr.error(response.message);
      return;
    }
    this.formControls.codigoEscolaApenasDiretoria.setValue(response.data.codigoEscola);
  }




  async searchHandler(event: FiltroPadrao) {
    this.filtros = event;


  }


  async listeningFiltroEmitter(eventFilter: FiltroPadrao) {
    this.setFilters(eventFilter);
    this.filtroService.atualizaFiltro(eventFilter);
  }

  setFilters(event: FiltroPadrao) {
    this.filtros = event;
  }



  public async getOcorrencias() {
    this.spinnerService.show();


    const codigoPsicologo = this.jornada?.codigoPsicologo;
    const codigoEscola =  this.formControls.codigoEscolaApenasDiretoria.value ?? this.jornada.codigoEscola ;
    const result = await lastValueFrom(this.chamadoService.getChamadosEncaminhadosParaPsicologo(codigoEscola, codigoPsicologo))
      .catch(err => this.convivaErrors.handleResultError(err));
    if (!result.isSucess) {
      this.spinnerService.hide();
      return;
    }



    this.lstOcorrenciasAgendadas = result.data.map((t: any) => ({
      ...t,
      // marca 'true' sempre que essa turma já estiver na lista de envolvidos da atividade
      acoes: this.atividade.codigoChamado == t.codigoChamado,
    }));
    this.getEnvolvidosPorChamado();

    this.spinnerService.hide();
  }

  public async getPrevencaoAgendada() {
    this.spinnerService.show();
    const codigoAgendamento = this.atividade.codigoAgendamento;

    const result = await lastValueFrom(this.psicologoService.getAgendamentosPrevencaoPorId(codigoAgendamento!))
      .catch(err => this.convivaErrors.handleResultError(err));
    // this.lstAgendamentoPrevencao = result.data;

    this.formControls.codigoEscolaApenasDiretoria.setValue(result.data.codigoEscola);
    this.formControls.codigoEscolaApenasDiretoria.disable();
    this.lstAgendamentoPrevencao = [{ ...result.data, acoes: true }]
    this.spinnerService.hide();

  }


  public async editarAtividade() {
    this.submitted = true;
    if (this.formEditar.invalid) {
      this.toastr.error('Preencha os campos obrigatórios');
      return;
    }

    if (this.lstEnvolvidosSelecionados.length == 0 &&
      this.alunosSelecionados.length == 0 &&
      this.lstOutros.length == 0 &&
      this.lstFuncionariosSelecionados.length == 0 &&
      this.lstTurmasSelecionadas.length == 0
      && !this.atividade.codigoAgendamento) {
      this.toastr.error('A atividade precisa ter ao menos 1 envolvido');
      this.spinnerService.hide();
      return;
    }

    this.spinnerService.show();
    const body = this.setBodyParameters(this.formEditar.value);
    const response = await lastValueFrom(this.psicologoService.setAtualizarAtividade(body));
    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    this.toastr.success("Atividade editada com sucesso!", "Tudo certo!");
    this.toastr.success("Redirecionando em 5 segundos");
    setTimeout(() => {
      this.location.back();
    }, 5000);
    this.spinnerService.hide();
    return;
  }

  public setBodyParameters(form: any): EditarJornadaAtividade {

    return {
      codigoAtividade: this.atividade.codigoAtividade,
      titulo: form.tituloAcao,
      descricaoAcaoRealizada: form.acaoRealizada,
      descricaoProximosPassos: form.proximosPassos,
      arquivos: this.files,
      envolvidos: this.mapeiaEnvolvidos(),
      tempoAtividade: form.duracaoAcao.toString(),
      codigoChamado: this.codigoNovoChamado,
      codigoAgendamento: this.codigoAgendamento,
      codigoUsuario: this.userLogado?.codigoUsuario!,
      nomeUsuario: this.userLogado?.nome!,
      dataAtividade: form.dataAtividade
    };

  }

  private mapeiaEnvolvidos(): JornadaPsicologoAtividadeEnvolvido[] {


    let todosEnvolvidos: JornadaPsicologoAtividadeEnvolvido[] = []


    if (this.lstTurmasSelecionadas.length > 0) {
      todosEnvolvidos = this.lstTurmasSelecionadas;
    }


    if (this.lstEnvolvidosSelecionados.length > 0) {
      todosEnvolvidos = this.lstEnvolvidosSelecionados.map(env => {
        return {
          codigoAtividadeEnvolvido: this.atividade.envolvidos.find((env2) => env2.codigoEnvolvido == env.codigoEnvolvido)?.codigoAtividadeEnvolvido,
          codigoAtividade: this.atividade.codigoAtividade,
          tipoPessoa: 1,
          codigoAluno: env.codigoAluno,
          nomeAluno: env.nome,
          numeroRa: env.ra,
          codigoEnvolvido: env.codigoEnvolvido,
          codigoTurma: env.codigoTurma,
          descricaoTurma: env.descricaoTurma,
        }
      })

    }


    if (this.alunosSelecionados.length > 0) {
      todosEnvolvidos = todosEnvolvidos.concat(this.alunosSelecionados.map(aluno => {
        return {
          codigoAtividadeEnvolvido: this.atividade.envolvidos.find((env2) => env2.codigoAluno == aluno.codigoAluno)?.codigoAtividadeEnvolvido,
          codigoAtividade: this.atividade.codigoAtividade,
          tipoPessoa: 1,
          codigoAluno: aluno.codigoAluno,
          nomeAluno: aluno.nomeAluno,
          numeroRa: aluno.numeroRa,
          codigoEnvolvido: aluno.codigoEnvolvido,
          codigoTurma: aluno.codigoTurma,
          descricaoTurma: aluno.descricaoTurma
        }
      }))

    }

    if (this.lstOutros.length > 0) {
      todosEnvolvidos = todosEnvolvidos.concat(this.lstOutros.map(out => {
        return {
          codigoAtividadeEnvolvido: this.atividade.envolvidos.find((env2) => env2.outros == out)?.codigoAtividadeEnvolvido,
          codigoAtividade: this.atividadeId,
          outros: out,
          tipoPessoa: 3
        }
      }))
    }

    if (this.lstFuncionariosSelecionados.length > 0) {
      todosEnvolvidos = todosEnvolvidos.concat(this.lstFuncionariosSelecionados.map(equipe => {
        return {
          codigoAtividadeEnvolvido: this.atividade.envolvidos.find((env2) => env2.numeroCpf == Number(equipe.cpf))?.codigoAtividadeEnvolvido,
          codigoAtividade: this.atividadeId,
          nomeEquipeEscolar: equipe.nome,
          tipoPessoa: 2,
          numeroCpf: Number(equipe.cpf)
        }
      }))
    }

    return todosEnvolvidos;
  }


  public tiposAtividade = [
    { label: 'Acolhimento', value: 1 },
    { label: 'Acolhimento Agendado', value: 2 },
    { label: 'Prevenção', value: 3 },
    { label: 'Prevenção Agendado', value: 4 }
  ];

  public async onTipoAtividadeChange(tipoAtividade: number): Promise<void> {

    if (tipoAtividade === 1) {
      this.mostrarAgendados = false;
      this.mostrarNaoAgendados = true;
    }
    if (tipoAtividade === 2) {
      this.mostrarGridAcolhimento = true;
      this.mostrarAgendados = true;
      this.mostrarGridPrevencao = false;
      this.mostrarNaoAgendados = false;
      await this.getChamadoPorId();
      await this.getOcorrencias();

    }

    if (tipoAtividade === 3) {
      this.mostrarAgendados = false;
      this.mostrarNaoAgendados = true;
    }

    if (tipoAtividade === 4) {
      await this.getPrevencaoAgendada();
      this.mostrarGridAcolhimento = false;
      this.mostrarGridPrevencao = true;
      this.mostrarAgendados = true;
      this.mostrarNaoAgendados = false;
    }
  }

  // public async getPsicologoPorCPF(): Promise<void> {
  //   const cpf = this.userLogado?.cpf;
  //   if (!cpf) {
  //     return;
  //   }

  //   try {
  //     const result = await lastValueFrom(this.psicologoService.getPsicologoPorCPF(cpf));
  //     this.psicologo = result.data;
  //   } catch (err) {
  //     this.errorHandler.handleResultError(err);
  //   }
  // }

  public lstAtividadeRealizada = [{ id: 1, name: "Conversa/atividade individual com estudante" },
  { id: 2, name: "Conversa/atividade em grupo" },
  ];

  public lstGrupos = [{ id: 1, name: "Turmas participantes da atividade" }, { id: 2, name: "Equipe escolar" }, { id: 3, name: "Outros" }];
  public tipoPessoaAdd = [{
    descricao: 'Outros',
    id: 1
  }, {
    descricao: 'Profissional',
    id: 2
  }]

  public IsEnvolvidoSelected(envolvido: Envolvido): boolean {
    return this.lstEnvolvidosSelecionados.includes(envolvido);
  }


  public opcoesPrevencao() {
    const codigoAtividade = this.formEditar.get('atividadeRealizada')?.value;

    if (codigoAtividade == 1) {
      this.mostrarAlunosPrevencao = true;
      this.mostrarGrupos = false;
    }

    if (codigoAtividade == 2) {
      this.mostrarAlunosPrevencao = false;
      this.mostrarGrupos = true;
    }



  }

  public AbreModalAluno() {
    this.showModalAluno = true;
    this.formModalAluno = new FormGroup({
      codigoDiretoriaModal: new FormControl(null, [Validators.required]),
      codigoEscolaModal: new FormControl(null, [Validators.required]),
      raAlunoModalDrop: new FormControl(null),
      raNomeAluno: new FormControl(null, [Validators.required])
    })
    this.UserBehavior();
  }

  public removeAluno(codigoAluno: number) {
    this.alunosSelecionados = this.alunosSelecionados.filter(x => x.codigoAluno != codigoAluno)
  }

  public FecharModalAluno() {
    this.showModalAluno = false;

    const campos = ['codigoDiretoriaModal', 'codigoEscolaModal', 'raNomeAluno'];
    campos.forEach(campo => {
      const controle = this.formModalAluno.get(campo);
      if (controle) {
        controle.clearValidators();
        controle.updateValueAndValidity();
      }
    });

    this.resetModalEnvolvidos();
  }

  public resetModalEnvolvidos() {
    this.formModalAluno.reset();

  }

  public OnAdicionarEnvolvido() {
    if (this.formModalAluno.invalid) {
      this.toastr.warning("Selecione um aluno para salvar na atividade.");
      return;
    }


    const alunoSelecionado = this.alunos.find(x => x.ra == this.formModalAluno.get('raAlunoModalDrop')?.value)!;
    if (this.alunosSelecionados.some(x => x.codigoAluno == alunoSelecionado.codigoAluno)) {
      this.toastr.warning("Aluno já adicionado.");
      return;
    }
    this.alunosSelecionados.push({
      codigoAtividade: this.atividade.codigoAtividade,
      tipoPessoa: 1,
      codigoAluno: alunoSelecionado.codigoAluno,
      nomeAluno: alunoSelecionado.nomeAluno,
      numeroRa: alunoSelecionado.ra,
      codigoTurma: alunoSelecionado.codigoTurma,

    });

    this.lstEnvolvidosSelecionados.push()
    this.showDropAuxiliar = false;
    this.showModalAluno = false;
    this.resetModalEnvolvidos();
  }

  public async getEscolasModalEnvolvidos() {
    this.spinnerService.show();
    this.zerarEscolaModal();

    const codigoDE = this.formModalAluno.get('codigoDiretoriaModal')?.value;

    if (codigoDE) {
      const result = await lastValueFrom(this.escolaService.getEscolasPorCodigoDiretoria(codigoDE))
        .catch((err) => {
          return this.errorHandler.handleResultError(err);
        });
      if (!result.isSucess) {
        this.toastr.error(result.message, result.title);
        this.spinnerService.hide();
        return;
      }

      this.escolasModalAlunos = result.data;
      this.formModalAluno.get('codigoEscolaModal')?.enable();
      this.spinnerService.hide();
    } else {
      this.escolasModalAlunos = [];
      this.spinnerService.hide();
    }
  }

  zerarEscolaModal() {
    this.escolasModalAlunos = [];
  }


  public BuscarAlunoPorNomeRA() {
    const regexNumeros = /\d$/;
    const regexLetras = /^[a-zA-Z]+$/;
    const regexAmbos = /^[a-zA-Z0-9]+$/;

    this.formModalAluno.get('raAlunoModalDrop')?.patchValue(null);
    this.formModalAluno.get('raAlunoModalDrop')?.removeValidators([Validators.required]);
    this.validaBuscaRA = false;
    const nomeRa = this.formEditar.get('raNomeAluno')?.value;

    let buscarPorRa = false;

    if (regexNumeros.test(nomeRa)) {
      this.formModalAluno.get('codigoDiretoriaModal')?.clearAsyncValidators();
      this.formModalAluno.get('codigoEscolaModal')?.clearAsyncValidators();
      buscarPorRa = true;
    }
    else if (regexLetras.test(nomeRa)) {
      this.validaBuscaRA = true;
      this.formModalAluno.get('codigoDiretoriaModal')?.addValidators([Validators.required]);
      this.formModalAluno.get('codigoEscolaModal')?.addValidators([Validators.required]);
    }
    else if (regexAmbos.test(nomeRa)) {
      this.validaBuscaRA = true;
      this.formModalAluno.get('raNomeAluno')?.setValue(nomeRa.replace(/\d/g, ''));
    }
    else {
    }
    this.AtualizarValidacoesAlunos();

    if (this.formModalAluno.invalid) {
      this.toastr.warning("Deverá ser selecionado o aluno ofendido/ofensor");
      return;
    }
    if (buscarPorRa) {
      this.getAlunosPorRa();
    } else {
      this.getAlunosPorNome();
    }
    this.formModalAluno.get('raAlunoModalDrop')?.addValidators([Validators.required]);
    this.AtualizarValidacoesAlunos();
  }

  public AtualizarValidacoesAlunos() {
    this.formModalAluno.get('codigoDiretoriaModal')?.updateValueAndValidity();
    this.formModalAluno.get('codigoEscolaModal')?.updateValueAndValidity();
    this.formModalAluno.get('raNomeAluno')?.updateValueAndValidity();
    this.formModalAluno.get('raAlunoModalDrop')?.updateValueAndValidity();
  }

  public async getAlunosPorRa() {
    this.spinnerService.show();
    this.showDropAuxiliar = false;
    const raAluno = this.formModalAluno.get('raNomeAluno');
    const result = await lastValueFrom(this.alunoService.getAlunosPorRa(raAluno?.value))
      .catch((err) => {
        return this.errorHandler.handleResultError(err);
      });
    if (!result.isSucess) {
      this.toastr.error(result.message, result.title);
      this.spinnerService.hide();
      return;
    }
    this.RetornoBuscaAlunoPorRA(result);
    this.spinnerService.hide();
  }

  private RetornoBuscaAlunoPorRA(response: DefaultResponse) {
    if (response.data != null) {
      this.aluno = response.data;
      this.formModalAluno.get('raAlunoModalDrop')?.patchValue(response.data.ra);
      this.alunos.push(this.aluno);
      this.showDropAuxiliar = true;
      this.toastr.success('Aluno carregado com sucesso.');
      return;
    }
    this.toastr.warning('Nenhum aluno encontrado!');
  }

  public async getAlunosPorNome() {
    const nmAluno = this.formModalAluno.get('raNomeAluno')?.value;
    const codigoDiretoria = this.formModalAluno.get('codigoDiretoriaModal')?.value;
    const codigoEscola = this.formModalAluno.get('codigoEscolaModal')?.value;
    this.spinnerService.show();
    this.showDropAuxiliar = false;
    const result = await lastValueFrom(this.alunoService.getAlunosPorNome(nmAluno, codigoDiretoria, codigoEscola))
      .catch((err) => {
        return this.errorHandler.handleResultError(err);
      });
    if (!result.isSucess) {
      this.toastr.error(result.message, result.title);
      this.spinnerService.hide();
      return;
    }
    this.RetornoBuscaAlunos(result);
    this.spinnerService.hide();
  }

  private RetornoBuscaAlunos(response: DefaultResponse) {
    if (response.data != null) {
      this.alunos = response.data;
    }
    if (this.alunos.length == 0) {
      this.toastr.warning('Nenhum aluno encontrado!');
    }
    if (this.alunos.length == 1) {
      this.formModalAluno.get('raAlunoModalDrop')?.patchValue(this.alunos[0].ra);
    }
    if (this.alunos.length > 1) {
      this.toastr.success('Alunos carregados com sucesso. Por favor selecione um.');
    }
    this.showDropAuxiliar = true;
  }


  public async UserBehavior() {


    if (this.userLogado?.flPsicologo) {
      await this.getDiretoriasPerfilPsicologo();
    }
    else {
      if (this.atribuicoesLogin.NumeroComportamento == 1) {
        await this.getDiretoriasAdmin();
      }

      if (this.atribuicoesLogin.NumeroComportamento == 2) {
        await this.getDiretoriasPerfilDiretoria();
      }

      if (this.atribuicoesLogin.NumeroComportamento == 3 ||
        this.atribuicoesLogin.NumeroComportamento == 4) {
        await this.getDiretoriasPerfilEscola();
      }
    }


    // this.disableVoidInputs();
    await this.activeDiretoria();
  }


  private async getDiretoriasPerfilPsicologo() {
    this.spinnerService.show();
    const response = await lastValueFrom(this.psicologoService.getDiretoriaPorPolo(this.userLogado!.codigoPolo));
    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    this.diretorias = response.data;
    this.spinnerService.hide();


  }

  public async getDiretoriasAdmin() {
    this.spinnerService.show();


    const response = await lastValueFrom(this.escolaService.getDiretoriaPorTipoDiretoria())
      .catch((err) => {
        return this.errorHandler.handleResultError(err);
      });

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    this.diretorias = response.data;
    this.spinnerService.hide();


  }


  public getDiretoriasPerfilDiretoria() {
    this.diretorias = [];
    this.escolas = [];
    this.spinnerService.show();

    this.userLogado?.DadosUsuario?.map((item: AtribuicaoLoginSed) => {
      const diretoria = new Diretoria();
      diretoria.codigoDiretoria = item.CodigoDiretoria;
      diretoria.nomeDiretoria = item.NomeDiretoria;
      this.diretorias.push(diretoria);

    });

    if (this.diretorias.length === 1) {
      this.formEditar.get('codigoDiretoria')!.disable();
    }

    this.spinnerService.hide();

  }


  public getDiretoriasPerfilEscola() {

    this.diretorias = [];
    this.escolas = [];

    this.spinnerService.show();
    this.userLogado?.DadosUsuario?.map((item: AtribuicaoLoginSed) => {
      const diretoria = new Diretoria();
      diretoria.codigoDiretoria = item.CodigoDiretoria;
      diretoria.nomeDiretoria = item.NomeDiretoria;
      this.diretorias.push(diretoria);

      const escola = new Escola();
      escola.codigoEscola = item.CodigoEscola;
      escola.nomeEscola = item.NomeEscola;
      escola.codigoDiretoria = item.CodigoDiretoria;
      this.escolas.push(escola);
      this.escolasDiretor.push(escola);

    });
    this.spinnerService.hide();



  }

  // disableVoidInputs() {

  //   // if(this.template == TemplateFiltroPadrao.Polo){
  //   //   this.form.codigoDiretoria.setValue(null);
  //   //   this.form.codigoDiretoria.disable();
  //   // }
  //   this.formEditar.get('codigoDiretoria')!.setValue(null);
  //   this.formEditar.get('codigoDiretoria')!.disable();
  //   this.formEditar.get('codigoEscola')!.setValue(null);
  //   this.formEditar.get('codigoEscola')!.disable();
  // }


  async activeDiretoria() {

    if (this.diretorias != undefined && this.userLogado?.codigoDiretoria != 0) {
      const diretoria = this.diretorias.find(s => s.codigoDiretoria == this.userLogado?.codigoDiretoria)
      if (diretoria) {
        this.formEditar.get('codigoDiretoria')?.setValue(this.userLogado?.codigoDiretoria);
        this.formEditar.get('codigoDiretoria')?.enable();
        await this.getEscolas();
      }
    }
  }


  async activeEscola() {
    if (this.escolas != undefined && this.userLogado?.codigoEscola != 0) {
      const escola = this.escolas.find(s => s.codigoEscola == this.userLogado?.codigoEscola)
      if (escola) {
        this.formEditar.get('codigoEscola')!.setValue(this.userLogado?.codigoEscola);
      }
    }
  }

  public async getEscolas() {
    this.spinnerService.show();

    const codigoDE = this.formEditar.get('codigoDiretoria');
    if (this.userLogado?.DadosUsuario[0]?.NumeroComportamento == 1 ||
      this.userLogado?.DadosUsuario[0]?.NumeroComportamento == 2 ||
      this.userLogado?.DadosUsuario[0].CodigoPerfil == Perfil.Psicólogo) {
      //this.zerarEscola();
      if (codigoDE?.value != null) {
        this.spinnerService.show();
        const response = await lastValueFrom(this.escolaService.getEscolasPorCodigoDiretoria(codigoDE?.value));
        if (!response.isSucess) {
          this.toastr.error(response.message);
        }
        this.escolas = response.data;
        this.formEditar.get('codigoEscola')!.enable();
        this.spinnerService.hide();
      }
    }
    this.spinnerService.hide();
  }


  public async mostrarTipoGrupo() {
    const tipoGrupo = this.formEditar.get('tipoGrupo')?.value;
    this.OnLimparEnvolvidos();
    if (tipoGrupo == 1) {
      //turmas participantes da atividade
      this.mostrarDivTurmas = true;
      // this.lstTurmas = this.mapeiaEnvolvidoParaTurma(this.atividade.envolvidos)
      await this.getTurmaPorId();

      this.carregarTurmas();
      this.lstTurmasSelecionadas = this.atividade.envolvidos;
      this.mostrarDivEquipeEscolar = false;
      this.mostrarDivOutros = false;
      // this.mostrarDivOutros = false;
    } else if (tipoGrupo == 2) {
      // equipe escolar
      this.mostrarDivTurmas = false;
      this.lstFuncionariosSelecionados = this.atividade.envolvidos.map(func => {
        return {
          cpf: func.numeroCpf?.toString()!,
          nome: func.nomeEquipeEscolar!,
          rg: '',
          email: '',
          codigoFuncionario: 0
        }
      })
      this.mostrarDivEquipeEscolar = true;
      this.mostrarDivOutros = false;
    } else if (tipoGrupo == 3) {
      // outros
      this.mostrarDivTurmas = false;
      this.lstOutros = this.atividade.envolvidos.map(env => env.outros!)
      this.mostrarDivEquipeEscolar = false;
      this.mostrarDivOutros = true;
    } else {
      this.mostrarDivTurmas = false;
      this.mostrarDivEquipeEscolar = false;
      this.mostrarDivOutros = false;
    }
  }



  public OnLimparEnvolvidos() {
    this.spinnerService.show();
    this.lstTurmas = [];
    this.lstTurmasSelecionadas = [];
    // this.lstTurmaAluno = [];
    this.lstEnvolvidos = [];
    // this.lstTurmasAtivas = [];
    // this.lstFuncionarios = [];
    // this.lstFuncionariosSelecionados = [];
    this.lstEnvolvidosSelecionados = [];
    this.alunosSelecionados = [];
    // this.files = [];
    // this.envolvidos = [];
    // this.showGridTurma = false;
    // this.mostrarDivEquipeEscolar = false;
    this.mostrarDivTurmas = false;
    // this.mostrarDivOutros = false;
    this.spinnerService.hide();
  }


  public async onCheckTurma(codigoTurma: number, descricaoTurma: string) {
    if (this.lstTurmasSelecionadas.some(x => x.codigoTurma == codigoTurma)) {
      this.lstTurmasSelecionadas = this.lstTurmasSelecionadas.filter(t => t.codigoTurma != codigoTurma)
    } else {
      const turmaAdd = this.lstTurmas.filter(t => t.codigoTurma == codigoTurma).map(turma => {
        return {
          codigoAtividadeEnvolvido: this.atividade.envolvidos.find((env2) => env2.codigoTurma == turma.codigoTurma)?.codigoAtividadeEnvolvido,
          codigoAtividade: this.atividade.codigoAtividade,
          tipoPessoa: 4,
          codigoTurma: turma.codigoTurma,
          descricaoTurma: turma.descricaoTurma,
          nomeTipoEnsino: turma.nomeTipoEnsino,
          numeroClasse: turma.numeroClasse,
          numeroSerie: turma.numeroSerie
        }
      })
      this.lstTurmasSelecionadas.push(turmaAdd[0])
    }

  }

  public OnExcluirEquipeEscolar(equipeEscolar: Funcionario) {
    this.lstFuncionariosSelecionados = this.lstFuncionariosSelecionados.filter(
      (envolvido) => envolvido.cpf !== equipeEscolar.cpf
    );
  }

  public AbrirModalEquipeEscolar() {
    this.submittedModal = false;
    this.formModalEquipeEscolar = new FormGroup({
      cpfFuncionario: new FormControl(null, [
        Validators.required,
        this.genericValidate.ValidaCpf,
      ]),
      cpfFuncionarioModalDrop: new FormControl(null, [Validators.required]),
    });
    this.showModalEquipeEscolar = true;
  }

  public FecharModalEquipeEscolar() {

    this.showModalEquipeEscolar = false;
    this.lstFuncionarios = [];
  }

  public OnAdicionarEquipeEscolar() {
    if (this.formModalEquipeEscolar.invalid) {
      return;
    }

    const funcionario = this.lstFuncionarios.find(x => x.cpf == this.formModalEquipeEscolar.get('cpfFuncionarioModalDrop')?.value);
    if (!funcionario) {
      this.toastr.error("Funcionário não encontrado");
      return;
    }

    if (this.lstFuncionariosSelecionados.some(x => x.cpf == this.formModalEquipeEscolar.get('cpfFuncionarioModalDrop')?.value)) {
      this.toastr.warning("Não é possivel adicionar o mesmo funcionario mais de uma vez", "Atenção!");
      return;
    }
    this.lstFuncionariosSelecionados.push(funcionario);

    this.toastr.success(`Equipo Escolar inserido com sucesso`);
    this.FecharModalEquipeEscolar();
  }


  OnChangeCountLetters(campo: number) {
    const avalia = this.formEditar.get('acaoRealizada')!.value;
    const impacto = this.formEditar.get('proximosPassos')!.value;
    if (avalia != null && campo == 1)
      this.qtdeCaracteresAcao = avalia.length;
    if (impacto != null && campo == 2)
      this.qtdeCaracteresPassos = impacto.length;
  }

  public AbrirModalOutros() {
    this.submittedModal = false;
    this.formModalOutros = new FormGroup({
      dsOutros: new FormControl(null, [Validators.required, Validators.maxLength(225)]),
    });
    this.showModalOutros = true;
  }


  public OnExcluirOutro(outro: string) {
    this.lstOutros = this.lstOutros.filter(x => x !== outro);
  }


  public async GetFuncionariosPorCpf(tela: number) {

    const cpf = tela == 1 ? this.formModalEquipeEscolar.get('cpfFuncionario')?.value : this.formModalEquipeEscolar.get('cpfBusca')?.value;
    if (!cpf) {
      this.toastr.warning("Digite um cpf para pesquisar", "Atenção");
      return;
    }
    if (!this.validarCPF(cpf)) {
      this.toastr.warning('CPF invalido.');
      this.spinnerService.hide();
      return;
    }
    this.showDropAuxiliar = false;
    this.showDropFuncionarios = false;
    this.spinnerService.show();
    let getCPF = undefined;
    if (tela == 1) {
      getCPF = this.formModalEquipeEscolar.get('cpfFuncionario');
    }
    else {
      getCPF = this.formModalEquipeEscolar.get('cpfBusca');
    }
    const result = await lastValueFrom(this.funcionarioService.getFuncionariosPorCpf(getCPF?.value.replace(".", "").replace("-", "")))
      .catch((err) => {
        return this.errorHandler.handleResultError(err);
      });
    if (!result.isSucess) {
      this.toastr.error(result.message, result.title);
      this.spinnerService.hide();
      return;
    }
    if (result.data != null) {
      this.lstFuncionarios = result.data;
    }
    if (tela == 2) { this.showDropFuncionarios = true; } else { this.showDropAuxiliar = true; }
    if (this.lstFuncionarios.length == 0) {
      this.toastr.warning('Nenhum funcionario encontrado!');
    } else {
      if (this.lstFuncionarios.length == 1) {
        if (tela == 1) {
          this.formModalEquipeEscolar.get('cpfFuncionarioModalDrop')?.patchValue(this.lstFuncionarios[0].cpf);
        } else {
          this.formModalEquipeEscolar.get('cpfProfissionalSelecionado')?.patchValue(this.lstFuncionarios[0].cpf);
        }

      }
    }

    this.spinnerService.hide();
  }

  validarCPF(cpf: string): boolean {
    cpf = cpf.replace(/[^\d]/g, '');
    if (cpf.length !== 11) {
      return false;
    }
    if (/^(\d)\1+$/.test(cpf)) {
      return false;
    }
    let sum = 0;
    let remainder;
    for (let i = 1; i <= 9; i++) {
      sum = sum + parseInt(cpf.substring(i - 1, i)) * (11 - i);
    }
    remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11) {
      remainder = 0;
    }
    if (remainder !== parseInt(cpf.substring(9, 10))) {
      return false;
    }
    sum = 0;
    for (let i = 1; i <= 10; i++) {
      sum = sum + parseInt(cpf.substring(i - 1, i)) * (12 - i);
    }
    remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11) {
      remainder = 0;
    }
    return remainder === parseInt(cpf.substring(10, 11));
  }


  public OnAdicionarOutros() {
    this.submittedModal = true;

    if (this.formModalOutros.invalid) {
      this.toastr.error("Campo de descrição obrigatório");
      return;
    }
    const descricao = this.formModalOutros.get('dsOutros')!.value as string;


    this.lstOutros.push(descricao);


    this.toastr.success("Descrição adicionada com sucesso!");
    this.formModalOutros.reset();
    this.submittedModal = false;
    this.FecharModalOutros();
  }

  public FecharModalOutros() {
    this.showModalOutros = false;
  }


  public removeUniqueId(fileName: string): string {
    const regex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}-/;
    return fileName.replace(regex, '');
  }

  public async OnFileChange(event: any) {

    const maxFileSize = 31 * 1024 * 1024; // 30 MB

    if (event.target.files.length > 0) {
      this.spinnerService.show();
      const formData = new FormData();
      const files = event.target.files;
      for (const file of files) {
        const fileName = file.name.split('.')[0];

        if (fileName.length > 30) {
          const fileInput = document.getElementById('arquivos') as HTMLInputElement;
          if (fileInput) {
            fileInput.value = '';
          }
          this.toastr.warning('O nome do arquivo não pode ter mais de 30 caracteres.');
          this.spinnerService.hide();
          return;
        }

        if (file.size > maxFileSize) {
          this.toastr.warning('O tamanho máximo do arquivo é 30 MB.');
          const fileInput = document.getElementById('arquivos') as HTMLInputElement;
          if (fileInput) {
            fileInput.value = '';
          }
          this.spinnerService.hide();
          return;
        }

        if (file.type == "image/jpg" ||
          file.type == "image/jpeg" ||
          file.type == "image/png" ||
          file.type == "application/pdf" ||
          file.type == "application/ppt" ||
          file.type == "application/pptx" ||
          file.type == "application/potx" ||
          file.type == "application/ppsx" ||
          file.type == "application/odp" ||
          file.type == "audio/mpeg" ||
          file.type == "video/mp4"
        ) {
          formData.append(file.name, file);
        }
        else {
          this.toastr.warning('Só é possivel subir arquivos .jpg, .jpeg , .png, .pdf, .mp3 , .mp4, .ppt, .pptx, .potx e ppsx');
          const fileInput = document.getElementById('arquivos') as HTMLInputElement;
          if (fileInput) {
            fileInput.value = '';
          }
          this.spinnerService.hide();
          return;
        }
      }


      const result = await lastValueFrom(this.arquivoService.setArquivoBase64(formData))
        .catch((err) => {
          return this.errorHandler.handleResultError(err);
        });

      if (!result.isSucess) {
        this.toastr.error(result.message, result.title);
        this.spinnerService.hide();
        return;
      }

      const novosFicheiros = result.data.map((arquivo: ArquivoAzure) => ({
        ...arquivo,
        dataOperacao: arquivo.dataOperacao || new Date(),
        nomeOriginal: arquivo.nomeOriginal || (arquivo.nome.length > 37 ? arquivo.nome.substring(37) : arquivo.nome)
      }));
      this.files.push(...novosFicheiros);
      event.target.value = '';
      this.spinnerService.hide();
    }
  }

public popupremoverarquivo(index: number) {
  this.spinnerService.show();
  this.showModalDeletarArquivo = true;
  this.spinnerService.hide();
  this.codigoArquivoRemover = index;
  this.arquivoRemover = this.files[index];
  return;
}

  public removeFile() {
    this.files.splice(this.codigoArquivoRemover!, 1);
    const fileInput = document.getElementById('arquivos') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
    this.FecharModalDeletarArquivo();
  }

  public FecharModalDeletarArquivo() {
    this.showModalDeletarArquivo = false;
  }

  disabilitaCamposNaoEditaveis() {
    this.formControls.tipoAtividade.disable();
    this.formControls.atividadeRealizada.disable();
    this.formControls.tipoGrupo.disable();
  }

  public onVoltar() {
    setTimeout(() => {
      this.location.back();
    }, 5000);

  }

  setChamadoAgendamento(rowData: any) {
    this.codigoNovoChamado = rowData.codigoChamado;
    if (this.atividade.codigoChamado != rowData.codigoChamado) {
      this.codigoAgendamento = rowData.codigoAgendamento;
    }
  }


  async onChangeCodigoEscola(event?: Escola) {

   const formData = this.formControls;
    this.lstEnvolvidosSelecionados = [];
    this.lstTurmas = [];
    this.lstTurmasSelecionadas = [];

    if (formData.tipoAtividade.value == 2){
      this.mostrarGridAcolhimento = true;
      await this.getOcorrencias();
    }

    if (formData.tipoAtividade.value == 4){

      this.mostrarGridPrevencao = true;
      await this.getPrevencaoAgendada();
    }


    if (formData.tipoAtividade.value == 1 || formData.tipoAtividade.value == 3){
      await this.carregarTurmas();

    }



  }


  async getEscolasApenasDiretoria() {
    this.spinnerService.show();

    const response = await lastValueFrom(this.escolaService.getEscolasPorCodigoDiretoria(this.jornada?.codigoDiretoria!));

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    this.escolas = response.data;

    this.spinnerService.hide();
  }


  async getChamadoPorId(){

    const response = await lastValueFrom(this.chamadoService.getChamadoPorId(this.atividade.codigoChamado!));
    if(!response.isSucess){
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    this.formControls.codigoEscolaApenasDiretoria.setValue(response.data.cdEscola);
    this.formControls.codigoEscolaApenasDiretoria.disable();

  }

  public async DownloadArquivo(index: number) {
    if (index < 0 || index >= this.files.length) {
      this.toastr.error('Arquivo não encontrado');
      return;
    }

    this.spinnerService.show();
    try {
      const arquivo = this.files[index];
      const response = await lastValueFrom(this.arquivoService.getArquivoPorNome(arquivo.nome));

      const url = window.URL.createObjectURL(response);
      const link = document.createElement('a');
      link.href = url;
      link.download = arquivo.nomeOriginal || arquivo.nome;
      link.click();
      window.URL.revokeObjectURL(url);

      this.toastr.success('Arquivo baixado com sucesso!');
    } catch (error) {
      console.error('Erro ao baixar arquivo:', error);
      this.toastr.error('Erro ao baixar o arquivo');
    } finally {
      this.spinnerService.hide();
    }
  }

  public visualizarAquivo(index: number): void {
    if (index >= 0 && index < this.files.length) {
      this.arquivoVisualizando = this.files[index];
      this.showModalVisualizarArquivo = true;
    }
  }

  public fecharModalVisualizarArquivo(): void {
    this.showModalVisualizarArquivo = false;
    this.arquivoVisualizando = undefined;
  }

}





